import axios from '../core/axios';

interface PowerBITokenResponse {
  reportId: string;
  embedUrl: string;
  accessToken: string;
  expiry?: string;
}

export const reportsService = {
  getEmbedToken: async (reportName: string): Promise<PowerBITokenResponse> => {
    try {
      const response = await axios.get<PowerBITokenResponse>('/powerbi/get-token', {
        params: { reportName, _t: Date.now() }
      });
      return response.data;
    } catch (error: any) {
      console.error('PowerBI Service Error:', error.message);
      if (error.response?.data) {
        console.error('Error Response Details:', error.response.data);
      }
      throw error;
    }
  }
};